import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Verein Guard - Erlaubt TRAINER, VEREINS_ADMIN und ADMIN
 * Diese Rollen können den Vereinsbereich (auch Schulungstage) öffnen
 */
export const vereinGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();

  if (user && (user.role === 'TRAINER' || user.role === 'VEREINS_ADMIN' || user.role === 'ADMIN')) {
    return true;
  }

  // Nicht autorisiert - zurück zum Dashboard
  router.navigate(['/dashboard']);
  return false;
};
